const readFlag = value => value === 'true'

export const IMAGE_INBOX_ENABLED = readFlag(import.meta.env.VITE_CVA_IMAGE_INBOX_ENABLED)
export const IMAGE_INBOX_MOCK_ENABLED = readFlag(import.meta.env.VITE_CVA_IMAGE_INBOX_MOCK_ENABLED)

export const IMAGE_INBOX_IMAGE_EXTENSIONS = new Set([
  'png',
  'jpg',
  'jpeg',
  'webp',
  'heic',
  'heif',
])

export const IMAGE_INBOX_DOCUMENT_EXTENSIONS = new Set([
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'txt',
  'csv',
])

export const IMAGE_INBOX_ACCEPTED_EXTENSIONS = new Set([
  ...IMAGE_INBOX_IMAGE_EXTENSIONS,
  ...IMAGE_INBOX_DOCUMENT_EXTENSIONS,
])

function toAcceptAttribute(extensions) {
  return [...extensions].map(extension => `.${extension}`).join(',')
}

export const IMAGE_INBOX_IMAGE_ACCEPT_ATTRIBUTE = toAcceptAttribute(IMAGE_INBOX_IMAGE_EXTENSIONS)

export const IMAGE_INBOX_ACCEPT_ATTRIBUTE = toAcceptAttribute(IMAGE_INBOX_ACCEPTED_EXTENSIONS)

export const IMAGE_INBOX_MAX_FILES_PER_BATCH = 50
export const IMAGE_INBOX_MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024

export const IMAGE_INBOX_DEFAULT_LIMIT = 24
export const IMAGE_INBOX_EXPORT_LIMIT = 100

export const IMAGE_INBOX_RETENTION_DAYS = 30
export const IMAGE_INBOX_EXPIRING_SOON_DAYS = 7

export const IMAGE_INBOX_UPLOAD_SETTINGS = {
  maxWidth: 1600,
  maxHeight: 1600,
  quality: 0.72,
  outputMimeType: 'image/jpeg',
}

export const IMAGE_INBOX_MOCK_MAX_INLINE_BYTES = 2 * 1024 * 1024

export const IMAGE_INBOX_MOCK_PREVIEW_SETTINGS = {
  maxWidth: 800,
  maxHeight: 800,
  quality: 0.6,
  outputMimeType: 'image/jpeg',
}

export const IMAGE_INBOX_UPLOAD_STATUS = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  DONE: 'done',
  FAILED: 'failed',
}
